<template>
  <div class="max-w-7xl mx-auto px-6 py-12">
    <h1 class="text-5xl font-extrabold text-center mb-12 text-gray-800">
      Профиль специалиста
    </h1>

    <div v-if="loading" class="text-center text-xl text-gray-500">Загрузка...</div>
    <div v-else-if="error" class="text-center text-xl text-red-500">{{ error }}</div>

    <div v-else class="grid grid-cols-1 lg:grid-cols-4 gap-6">
      <!-- Личная информация -->
      <div class="col-span-2 row-span-2 bg-gradient-to-r from-red-600 via-red-500 to-red-400 rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 ease-in-out transform hover:scale-105">
        <div class="w-24 h-24 bg-white text-red-600 rounded-full flex items-center justify-center text-5xl font-bold mb-6">
          {{ staff.full_name?.charAt(0) || 'N/A' }}
        </div>
        <h2 class="text-3xl font-extrabold text-white mb-4">{{ staff.full_name }}</h2>
        <p class="text-white mb-6 text-lg font-medium">{{ staff.role === "doctor" ? "Врач" : "Медсестра" }}</p>
        <ul class="text-white text-lg space-y-3">
          <li><strong>Пол:</strong> {{ staff.gender }}</li>
          <li><strong>Дата рождения:</strong> {{ staff.date_of_birth }}</li>
          <li><strong>Email:</strong> {{ staff.email }}</li>
          <li><strong>ИИН:</strong> {{ staff.iin }}</li>
          <li v-if="staff.user && staff.user.phone_number"><strong>Телефон:</strong> {{ staff.user.phone_number }}</li>
        </ul>
      </div>

      <!-- Описание -->
      <div v-if="staff.description" class="col-span-1 bg-gray-100 rounded-2xl shadow-md p-6 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105">
        <h3 class="text-2xl font-semibold text-red-500 mb-3">📋 Описание</h3>
        <p class="text-gray-700">{{ staff.description }}</p>
      </div>

      <!-- Средняя оценка -->
      <div v-if="averageRating" class="col-span-1 bg-gray-100 rounded-2xl shadow-md p-6 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105">
        <h3 class="text-2xl font-semibold text-red-500 mb-3">⭐ Оценка</h3>
        <p class="text-gray-700 text-3xl font-bold">{{ averageRating.toFixed(1) }} ★</p>
        <button
          @click="showReviews = true"
          class="mt-4 bg-red-500 text-white px-4 py-2 rounded-full hover:bg-red-600 transition"
        >
          Отзывы
        </button>
      </div>

      <!-- Сертификаты -->
      <div v-if="staff.certificates.length" class="col-span-1 lg:col-span-2 bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 ease-in-out transform hover:scale-105">
        <h3 class="text-3xl font-semibold text-red-800 mb-6 flex items-center">
          <span class="mr-3">🎓</span> Сертификаты и дипломы
        </h3>
        <ul class="space-y-6">
          <li v-for="(cert, index) in staff.certificates" :key="index" class="flex items-center justify-between p-6 bg-gradient-to-r from-red-100 via-red-50 to-red-100 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 ease-in-out transform hover:scale-105">
            <div class="flex items-center space-x-4 w-full">
              <span class="text-red-600 font-semibold text-xl truncate" :title="cert">{{ `Сертификат ${index + 1}` }}</span>
            </div>
            <div class="flex items-center space-x-4 justify-end w-full">
              <a :href="cert" target="_blank" class="text-[#292D3C] hover:text-[#E70000] text-lg font-semibold transition duration-200 hover:underline">
                Просмотр
              </a>
              <span class="ml-3 text-sm text-gray-400">(PDF)</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import MedicalStaffService from "@/services/MedicalStaffService";

export default {
  props: ["id"],
  data() {
    return {
      staff: null,
      loading: true,
      error: null,
      role: this.$route.query.role || null, // Получаем роль из query
      showReviews: false,
    };
  },
  computed: {
    averageRating() {
      if (!this.staff?.reviews?.length) return null;
      const total = this.staff.reviews.reduce((sum, review) => sum + review.rating, 0);
      return total / this.staff.reviews.length;
    },
  },
  methods: {
    async loadMedicalInfo() {
      try {
        this.loading = true;
        this.staff = await MedicalStaffService.getMedicalInfoById(this.id, this.role);
      } catch (error) {
        console.error("Ошибка загрузки профиля:", error);
        this.error = "Не удалось загрузить данные профиля.";
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    if (!this.role) {
      this.error = "Роль не указана. Пожалуйста, вернитесь и выберите специалиста.";
      this.loading = false;
    } else {
      this.loadMedicalInfo();
    }
  },
};
</script>

<style scoped>
.container {
  max-width: 1024px;
  margin: 0 auto;
  padding: 2rem;
}
</style>
